<script>
import InsuredsListItem from "@/views/tourism/components/InsuredsListItem.vue";
import DocumentsBlock from "@/components/app/forms/DocumentsBlock.vue";
import validateForm from "@/views/tourism/mixins/validateForm";
import {getData} from "@/api/client";


//TODO move some data to vuex and refactoring

export default {
  name: "PayerForm",
  components: {DocumentsBlock, InsuredsListItem},
  model: {
    prop: 'payer',
    event: 'change',
  },
  props: ['payer', 'searchInfo', 'submitCheck'],
  mixins: [validateForm],
  computed: {
    offerInfo() {
      return this.$store.getters.GET_TOURISM_INFO_OFFER;
    },
    payerInnRequired() {
      return this.isInnRequiredByAge(this.payer.dateBirth);
    },
  },
  watch: {
    // Страхувальник досяг віку, з якого ІПН обов'язковий, — галочка
    // «Відсутній ІПН» ховається, тож її значення скидається.
    payerInnRequired: {
      immediate: true,
      handler(required) {
        if (required && this.payer && this.payer.withoutIdentificationCode) {
          this.payer.withoutIdentificationCode = false;
        }
      },
    },
    'payer.surname': function (newValue, oldValue) {
      if (this.isfillData == true) return;
      if (newValue && newValue.length >= 3) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(async () => {
          this.isLoadInsuredsListBySurname = true;
          await this.fetchClients(newValue, 'surname');
        }, 800);
      } else {
        this.insuredsListBySurname['payer'] = [];
        this.isLoadInsuredsListBySurname = false;
      }
    },
    'payer.identificationCode': function (newValue, oldValue) {
      if (this.isfillData == true) return;
      if (newValue && newValue.length >= 3) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(async () => {
          this.isLoadInsuredsListBySurname = true;
          await this.fetchClients(newValue, 'identificationCode');
        }, 800);
      } else {
        this.insuredsListBySurname['payer'] = [];
        this.isLoadInsuredsListBySurname = false;
      }
    },
  },
  data() {
    return {
      LetterMaskError: false,
      isLoadInsuredsListBySurname: false,
      isLoadInsuredsList: false,
      insuredsListBySurname: {},
      errors: [],
      insuredsList: {},
    }
  },
  methods: {
    fillClientData() {
      this.$emit('showFillClientDataModal', true);
    },
    selectInsuredInfo(insured) {
      this.isfillData = true;
      this.$emit('selectedPibInn', insured)
      // this.selectedPibInn = insured;
      this.clientId = insured.id;
      this.$store.commit('SET_CLIENT', insured.id);
      let selectDocument = false;
      let selectTourists = false;
      // insured.documents = this.getAllowedDocumentsTypes(insured.documents);
      if (insured.documents.length == 1) {
        selectDocument = insured.documents[0];
      }

      if (insured.insuredPeople.length == 1) {
        selectTourists = insured.insuredPeople;
      }

      let params = {
        "selectPibInn": insured,
        "selectDocument": selectDocument,
        "selectTourists": selectTourists,
      };

      if (!selectDocument || !selectTourists) {
        this.fillClientData();
        this.isfillData = false;
        return;
      }

      this.$emit('saveFillData', params)
      // this.saveFillData(params);
      this.isfillData = false;
    },
    async fetchClients(query, type) {
      if (!query) {
        this.isLoadInsuredsList = false;
        return;
      }
      this.insuredsList = [];
      let params = {
        "requestType": "clientsByUserId",
        "searchText": query,
        "customerType": this.orderData?.requestData?.customerType
      };
      clearTimeout(this.fetchClientsTimeout);
      this.fetchClientsTimeout = setTimeout(async () => {
        let response = await getData(params);
        if (type == "identificationCode") {
          this.insuredsList['payer'] = response.data.data.items;
        } else if (type == "surname") {
          this.insuredsListBySurname['payer'] = response.data.data.items;
        }
        this.isLoadInsuredsList = false;
        this.isLoadInsuredsListBySurname = false;
      }, 1000);
    },
    disableIdentificationCode() {
      if (this.payerInnRequired) {
        this.payer.withoutIdentificationCode = false;
        return;
      }
      this.payer.identificationCode = '';
      this.payer.withoutIdentificationCode = true;
    },
  }
}
</script>

<template>
  <div>
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <h3>
            <span>Дані страхувальника (Покупець)</span>
          </h3>
        </div>
        <div class="col-lg-12 row passport-row">
          <div class="col-lg-6">
            <div class="form-group surname-block">
              <label for="payer-surname">Прізвище *</label>
              <input v-model="payer.surname"
                     id="payer-surname"
                     maxlength="30"
                     type="text"
                     v-on:keypress="LetterMask($event)"
                     placeholder="Прізвище (Тільки латинськи літери)"
                     :class="[
                       'form-control surname-field',
                       {invalid: ((!$v.payer.surname.required && submitCheck) || (!$v.payer.surname.minLength) || (!$v.payer.surname.maxLength)) || (submitCheck && !onlyLatinCharacters(payer.surname))}
                       ]">
              <div v-if="isLoadInsuredsListBySurname" class="load-insured-list spinner-border spinner-border-sm"
                   style="top: 38px;" role="status"></div>
              <div v-if="insuredsListBySurname['payer'] && insuredsListBySurname['payer'].length > 0"
                   class="autocomplete-surname">
                <div @click="selectInsuredInfo(insured,'payer')" class="inn-items mb-1 mt-2"
                     v-for="insured in insuredsListBySurname['payer']">
                  <insureds-list-item :insured="insured"></insureds-list-item>
                </div>
              </div>
              <small class="error" v-if="!$v.payer.surname.required && submitCheck">Вкажіть прізвище (Тільки латинськи
                літери)</small>
              <small class="error" v-if="LetterMaskError || !onlyLatinCharacters(payer.surname)">Тільки латинські
                літери</small>
              <small class="error"
                     v-else-if="! $v.payer.surname.minLength || ! $v.payer.surname.maxLength">
                Введіть коректно прізвище</small>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="payer-name">Ім’я *</label>
              <input v-model="payer.name"
                     @change="/*getClientDataForUpdating()*/"
                     id="payer-name"
                     type="text"
                     placeholder="Ім’я (Тільки латинськи літери)" v-on:keypress="LetterMask($event)"
                     :class="['form-control', {invalid: ((!$v.payer.name.required && submitCheck) ||  (!onlyLatinCharacters(payer.name)  && submitCheck))}]">
              <small class="error" v-if="!$v.payer.name.required && submitCheck">Вкажіть ім’я </small>
              <small class="error" v-if="LetterMaskError || !onlyLatinCharacters(payer.name)">Тільки латинські
                літери</small>
            </div>
          </div>
        </div>
        <div class="col-lg-12 row passport-row">
          <div class="col-lg-6">
            <div class="form-group tooltip-group inn-block">
              <label for="payer.identificationCode">ІПН</label>
              <input type="text" placeholder="ІПН"
                     v-model="payer.identificationCode"
                     id="payer.identificationCode"
                     :disabled="payer.withoutIdentificationCode == true && !payerInnRequired"
                     :class="['form-control inn-field', {invalid: !$v.payer.identificationCode.matchesBirthDate || (!$v.payer.identificationCode.required && submitCheck) || (!$v.payer.identificationCode.customMinLength && submitCheck)}]"
                     v-mask="'##########'" maxlength="10">
              <div v-if="insuredsList['payer'] && insuredsList['payer'].length > 0" class="autocomplete-inn">
                <div @click="selectInsuredInfo(insured,'payer')" class="inn-items mb-1 mt-2"
                     v-for="insured in insuredsList['payer']">
                  <insureds-list-item :insured="insured"></insureds-list-item>
                </div>
              </div>
              <i v-if="! isLoadInsuredsList" data-html="true" data-toggle="tooltip" data-select="true"
                 title="" class="icon question"
                 data-original-title="<img src='https://ukasko.ua/images/tooltips/inn.png'>"></i>
              <div v-else class="load-insured-list spinner-border spinner-border-sm" style="top: 38px;" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <small class="error"
                     v-if="(!$v.payer.identificationCode.required && submitCheck)">Введіть ІПН</small>
              <small class="error"
                     v-else-if="(!$v.payer.identificationCode.customMinLength && submitCheck)">
                Введіть коректно ІПН
              </small>
              <small class="error"
                     v-else-if="!$v.payer.identificationCode.matchesBirthDate">
                ІПН та Дата народження не співпадають
              </small>
              <small v-if="!payerInnRequired">
                <div class="form-check">
                  <input v-model="payer.withoutIdentificationCode" @click="disableIdentificationCode()" type="checkbox"
                         class="form-check-input" id="withoutIdentificationCode">
                  <label class="form-check-label" for="withoutIdentificationCode">Відсутній ІПН</label>
                </div>
              </small>
              <small v-else class="text-muted d-block">
                ІПН обов'язковий для осіб від {{ tourismInnRequiredFromAge }} років
              </small>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="payer-date-birth">Дата народження *</label>
              <input v-mask="'##.##.####'" placeholder="Дата народження"
                     id="payer-date-birth"
                     v-model="payer.dateBirth"
                     :class="['form-control', 'form-input_date', {invalid: ((!$v.payer.dateBirth.required && submitCheck) ||
                                                                (!$v.payer.dateBirth.customMinLength && submitCheck) ||
                                                                  (errorBirthDate()) ||
                                                                  (!$v.payer.identificationCode.matchesBirthDate))}]">
              <small class="error"
                     v-if="!$v.payer.dateBirth.required && submitCheck">Введіть дату народження</small>
              <small class="error"
                     v-else-if="((!$v.payer.dateBirth.customMinLength || !$v.payer.dateBirth.daysInMonth) && submitCheck)">
                Введіть коректну дату народження</small>
              <small class="invalid-feedback error" v-else-if="hasError('payer.errorBirthDate')"
                     v-html="getError('payer.errorBirthDate')"></small>
              <small class="error" v-else-if="!$v.payer.identificationCode.matchesBirthDate">
                ІПН та Дата народження не співпадають
              </small>
            </div>
          </div>
        </div>
        <div class="col-lg-12 row passport-row">
          <div class="col-lg-6">
            <div class="form-group">
              <label for="payer-email">Email *</label>
              <input v-model.trim="payer.mail" @change="/*getClientDataForUpdating()*/" type="text"
                     id="payer-email"
                     placeholder="Ел. пошта"
                     :class="['form-control', {invalid: (!$v.payer.mail.required && submitCheck)}]">
              <small class="error" v-if="!$v.payer.mail.required && submitCheck">Вкажіть пошту</small>
              <small class="error" v-else-if="!$v.payer.mail.email">Введіть коректно пошту</small>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="payer-phone">Телефон *</label>
              <input v-model.trim="payer.phone" @change="/*getClientDataForUpdating()*/" v-mask="'+38 (0##) ###-##-##'"
                     id="payer-phone"
                     type="text" placeholder="Телефон"
                     :class="['form-control', {invalid: (!$v.payer.phone.required && submitCheck)}]">
              <small class="error" v-if="!$v.payer.phone.required && submitCheck">Вкажіть телефон</small>
              <small class="error" v-else-if="!$v.payer.phone.minLength">Введіть номер в форматі 380xxxxxxxx</small>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <DocumentsBlock
            ref="documents-block"
            :productType="5"
            :offerInfo="offerInfo"
            :searchInfo="searchInfo"
            :documentation="payer.documentation"
            :submitCheck="submitCheck"
            :dateBirth="payer.dateBirth"
          ></DocumentsBlock>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-group {
  .icon.question {
    top: 35px;
  }
  label {
    font-size: 15px;
  }
}

.invalid {
  border-color: #dc3545 !important;
}
</style>
